function dig(ob, path, defaultValue) {
  const def = typeof defaultValue !== 'undefined' ? defaultValue : false;
  if (!ob || typeof ob === 'undefined') {
    return def;
  }
  const part = path.shift();
  if (path.length > 0) {
    if (typeof ob[part] !== 'undefined') {
      return dig(ob[part], path, def);
    } else {
      return def;
    }
  } else if (typeof ob[part] !== 'undefined') {
    return ob[part];
  } else {
    return def;
  }
}

function getPropertyByPath(obj, path, defaultValue) {
  return dig(obj, path.split('.'), defaultValue);
}

export default {
  methods: {
    $varReplace(input) {
      if (typeof input === 'undefined' || input === '') {
        return '';
      }
      const matcher = /\$(.+?)\.(.+?)\$/gm;
      const result = [...input.matchAll(matcher)];
      // eslint-disable-next-line no-unused-vars
      for (const item of result) {
        let storeProperty, storeValue;
        if (item[1] === 'answers') {
          storeProperty = this.$store.state.answers;
          storeValue = storeProperty ? storeProperty[item[2]] : null;
        }
        if (item[1] === 'user') {
          storeValue =
            this.$store.state.answers.user[item[2]] ||
            this.$store.state.answers._userdata[item[2]];
        }
        if (item[1] === 'static') {
          storeProperty = this.$store.state.static;
          const value = getPropertyByPath(storeProperty, item[2], null);
          storeValue = storeProperty ? value : null;
        }
        if (item[1] === 'calc') {
          storeProperty = this.$store.state.calculations;
          const value = getPropertyByPath(storeProperty, item[2], null);
          storeValue = storeProperty ? value : null;
        }
        if (item[1] === 'scores') {
          storeProperty = this.$store.state.result.scores;
          const value = getPropertyByPath(storeProperty, item[2], null);
          storeValue = storeProperty ? value : null;
        }
        if (item[1] === 'pdfurl') {
          const uuid = this.$store.state.responseUUID;
          storeValue = `${window.convinceConfig.base}/responses/${uuid}`;
        }
        if (storeValue && typeof storeValue !== 'undefined') {
          input = input.replaceAll(item[0], storeValue);
        }
      }
      return input;
    },
    $t(defaultText, replacement, page) {
      const translations = this.$store.state.lang;
      if (typeof translations === 'undefined') {
        return this.$varReplace(defaultText);
      }
      const language = this.$store.state.language;
      if (typeof page === 'undefined') {
        const currentPage = this.$store.getters.currentPage;
        page = `pages.${currentPage.type}-${currentPage.key}`;
      }

      let translation;
      const key = `${page}.${replacement}.${language}`;
      translation = getPropertyByPath(translations, key, null);
      if (!translation) {
        if (this.$store.getters.multilingual) {
          console.log(
            `Missing text ${defaultText.substring(
              0,
              100
            )}... Looked here: ${key}`
          );
        }
        translation = defaultText;
      }
      return this.$varReplace(translation);
    },
  },
};
